import React, { useCallback } from 'react';
import useDragRotate from '../hooks/useDragRotate';
import CoinBack from './CoinBack';
import { sideFromAngle } from '../utils/coinSide';

/**
 * Welcome hero: the C4sh3r mark as the masthead.
 * The logo already spells the name in brushed steel, so there is no wordmark
 * beside it — it would say the same thing twice, in two different spellings.
 * - Logo is a 3D coin: click to flip, drag to rotate (with physics).
 */
const WelcomeHero = ({ logoSrc, tagline }) => {
  const { angle, isDragging, isAnimating, handlers, wasDragged, flip } = useDragRotate({ sensitivity: 0.7 });

  const handleClick = useCallback((e) => {
    e.stopPropagation();
    if (wasDragged()) return;
    flip(Math.random() > 0.5 ? 1 : -1, 0);
  }, [flip, wasDragged]);

  return (
    <div className="welcome-hero" data-testid="welcome-hero">
      <div className="welcome-hero-glow" aria-hidden="true" />

      <div className="welcome-hero-logo-wrap">
        <span className="welcome-hero-ring welcome-hero-ring-1" aria-hidden="true" />
        <span className="welcome-hero-ring welcome-hero-ring-2" aria-hidden="true" />
        <button
          type="button"
          className={`welcome-hero-logo-btn coin-stage${isDragging ? ' is-dragging' : ''}`}
          onClick={handleClick}
          aria-label="C4sh3r logo - click to flip, drag to rotate"
          title="Click para girar / arrastra"
          data-testid="welcome-hero-logo-btn"
          {...handlers}
        >
          <span
            className={`coin coin-md${isAnimating ? ' is-spinning' : ''}${isDragging ? ' is-dragging' : ''}`}
            style={{ transform: `rotateY(${angle}deg)` }}
            data-side={sideFromAngle(angle)}
            aria-hidden="true"
          >
            <span className="coin-face coin-front">
              <img
                src={logoSrc}
                alt="C4sh3r logo"
                className="welcome-hero-logo"
                data-testid="welcome-hero-logo"
                draggable={false}
              />
            </span>
            <span className="coin-face coin-back">
              <CoinBack size="md" qrValue="https://www.linkedin.com/in/c4sh3r/" />
            </span>
          </span>
        </button>
      </div>

      <div className="welcome-hero-text">
        {tagline && (
          <div className="welcome-hero-tagline" data-testid="welcome-hero-tagline">
            <span className="welcome-hero-bracket">[</span>
            <span className="welcome-hero-tagline-text">{tagline}</span>
            <span className="welcome-hero-bracket">]</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default WelcomeHero;
